export default () => {
    return {
        bankIdVerification: {
            type: '',
            shouldInitBankID: false,
            bankIdInProgress: false,
            autoStartToken: '',
            completeText: '',
            verificationText: '',
            bankIdErrorMessage: '',
            errorCount: 0,
            requireBankIdVerification: true
        },
        swishDetails: {
            newNumber: '',
            verifyCode: '',
            isValid: false,
            errorMessage: '',
            isCompany: false,
            isFetching: true
        },
        bankAccountDetails: {
            newClearingNumber: '',
            newAccountNumber: '',
            bankAccountSaved: false,
            bankUnknown: false,
            errorMessage: '',
            isMemberSetForPayout: false,
            isFetching: true
        },
        tink: {
            tinkOnboarding: false,
            iframeUrl: '',
            shouldInitTink: false,
            accounts: null,
            account: null,
            errorMessage: '',
            isFetching: false
        },
        updateStatus: {
            type: '',
            isUpdating: false,
            processCorrelationId: null,
            errorMessage: null,
            maskedAccountNumber: null
        },
        paypalDetails: {
            emailAddress: null
        },
        payouts: [],
        pagination: {},
        paginationLinks: []
    };
};
